import { memo } from "react";
import styles from "./styles.module.css";

interface Props {
  src: string;
  className?: string;
}

export const ImageTag = memo(({ src, className }: Props) => {
  return (
    <img
      src={src}
      className={styles["markdown-img"]}
      loading="lazy"
      decoding="async"
    />
  );
});

ImageTag.displayName = "ImageTag";
